/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { DAI_ZERO_REVIEW_MUTATION_RESULT_FIELDS } from '../fragments'

export const SET_DAI_ZERO_CROP_EXCLUSION = gql`
  ${DAI_ZERO_REVIEW_MUTATION_RESULT_FIELDS}
  mutation SetDAIZeroCropExclusion($input: SetDAIZeroCropExclusionInput!) {
    setDaiZeroCropExclusion(input: $input) {
      ...DAIZeroReviewMutationResultFields
    }
  }
`
